export const TYPES_LOAD_PROJECT = Object.freeze({
	AUTOMATIC: 'automatic',
	MANUAL: '',
});
